import { useState, useEffect, useRef } from 'react';
import camketImage from '../../../assets/images/camketChuyenDoiSo.jpg';

export default function Commitment() {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setIsVisible(true);
        });
      },
      { threshold: 0.1 }
    );
    const el = sectionRef.current;
    if (el) observer.observe(el);
    return () => { if (el) observer.unobserve(el); };
  }, []);

  const commitments = [
    {
      title: "Độc lập & Khách quan",
      description:
        "Tư vấn dựa trên nhu cầu thực tế, không phụ thuộc vào bất kỳ nhà cung cấp phần mềm/phần cứng nào.",
    },
    {
      title: "Tiêu chuẩn hóa & Mở rộng",
      description:
        "Thiết kế hệ thống theo tiêu chuẩn quốc tế, sẵn sàng cho việc mở rộng quy mô trong tương lai.",
    },
    {
      title: "Hợp tác Chiến lược",
      description:
        "Không chỉ là tư vấn, chúng tôi đồng hành cùng đội ngũ của bạn trong suốt quá trình vận hành.",
    },
  ];

  const meetingImageUrl = camketImage;

  return (
    <section
      ref={sectionRef}
      id="commitment"
      className="py-24 px-6 md:px-20 lg:px-40 bg-white dark:bg-slate-900 overflow-x-hidden"
    >
      <div className="max-w-[1200px] mx-auto w-full min-w-0">
        <div className="flex flex-col lg:flex-row gap-20 items-center">
          <div className="lg:w-1/2 min-w-0 w-full">
            <h2
              className={`text-4xl font-black mb-8 leading-tight text-primary dark:text-white transition-all duration-1000 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              Cam kết về
              <br />
              <span className="text-accent">Chất lượng & Trung lập</span>
            </h2>
            <p
              className={`text-lg text-slate-600 dark:text-slate-400 mb-8 transition-all duration-1000 delay-200 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
              }`}
            >
              Chúng tôi đặt giá trị kinh doanh của khách hàng lên hàng đầu. Sự
              thành công của dự án được đo lường bằng hiệu quả vận hành thực tế.
            </p>
            <div className="space-y-6">
              {commitments.map((item, index) => (
                <div
                  key={index}
                  className={`flex items-start gap-4 transition-all duration-700 ${
                    isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-6'
                  }`}
                  style={{ transitionDelay: `${400 + index * 100}ms` }}
                >
                  <div className="mt-1 text-accent flex-shrink-0">
                    <i className="ri-checkbox-circle-fill text-2xl" />
                  </div>
                  <div>
                    <h6 className="font-bold text-lg text-slate-900 dark:text-white">
                      {item.title}
                    </h6>
                    <p className="text-slate-500 dark:text-slate-400">
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div
            className={`lg:w-1/2 relative w-full min-w-0 transition-all duration-1000 delay-300 ${
              isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'
            }`}
          >
            <div className="w-full max-w-full aspect-square border-8 border-white dark:border-slate-800 rounded-3xl overflow-hidden shadow-2xl rotate-0 lg:rotate-3">
              <img
                src={meetingImageUrl}
                alt="Corporate meeting in a modern glass office focused on strategy"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -top-10 right-0 lg:-right-10 w-48 h-48 bg-primary/10 rounded-full blur-3xl pointer-events-none" />
          </div>
        </div>
      </div>
    </section>
  );
}
